import type { ExamDetails } from "../types";

const fetchExamDetails = async (_params: {
	examId: string;
	tenantId: string;
}): Promise<ExamDetails> => {
	return {
		id: "",
		exam: {
			id: "",
			name: "",
			icon: "",
			isActive: false,
			numericId: 0,
			category: [],
			bundles: [],
			created: "",
			updated: "",
			tenantId: "",
		},
		metadata: {
			examDate: "",
			isActiveExam: false,
		},
	};
};

export { fetchExamDetails };
